// src/utils/storage-keys.js
// localStorage aynı origin altında (domain + port) paylaşılır.
// Bu yüzden anahtarları projeye özel prefix ile tutuyoruz.

function sanitizeKey(value) {
  return String(value || '')
    .trim()
    .replace(/[^a-zA-Z0-9_-]+/g, '_')
    .replace(/^_+|_+$/g, '')
}

function normalizeProjectKey(key) {
  // Bazı ortamlarda project key yanlışlıkla kendi suffix'leriyle gelebiliyor.
  // Örn: "asli_app-versiyon-key" -> "asli"
  const k = String(key || '')
  const withoutSuffix = k.replace(/(_app[-_]?versiyon(-key)?|_app_versiyon|_app_version)$/i, '')

  return withoutSuffix.replace(/[:_ -]+$/g, '')
}

// Tercih: sadece env'den değiştirilebilsin.
// Öneri: .env.* içine VUE_APP_PROJECT_KEY=... ekleyin.
const rawProjectKey = process.env.VUE_APP_PROJECT_KEY || process.env.VUE_APP_ROUTE || process.env.BASE_URL || 'app'
const PROJECT_KEY_RAW = sanitizeKey(rawProjectKey) || 'app'
export const PROJECT_KEY = normalizeProjectKey(PROJECT_KEY_RAW) || 'app'

// İstenen sade format: "<project>_app-versiyon"
export const APP_VERSION_STORAGE_KEY = `${PROJECT_KEY}_app_versiyon`

// Geriye dönük uyumluluk (eski anahtar)
export const LEGACY_APP_VERSION_STORAGE_KEY = 'app_version'
export const LEGACY_PROJECT_APP_VERSION_STORAGE_KEY = `${PROJECT_KEY}:app_version`
export const LEGACY_PROJECT_APP_VERSION_STORAGE_KEY_RAW = `${PROJECT_KEY_RAW}:app_version`
export const LEGACY_APP_VERSION_STORAGE_KEY_RAW_UNDERSCORE = `${PROJECT_KEY_RAW}_app_versiyon`
export const LEGACY_APP_VERSION_STORAGE_KEY_RAW_HYPHEN = `${PROJECT_KEY_RAW}_app-versiyon`

export function migrateLegacyAppVersionStorageKey() {
  try {
    const current = localStorage.getItem(APP_VERSION_STORAGE_KEY)
    if (current) return

    const candidates = [
      LEGACY_APP_VERSION_STORAGE_KEY_RAW_UNDERSCORE, // örn: asli_app-versiyon-key_app_versiyon
      LEGACY_APP_VERSION_STORAGE_KEY_RAW_HYPHEN,
      LEGACY_PROJECT_APP_VERSION_STORAGE_KEY,
      LEGACY_PROJECT_APP_VERSION_STORAGE_KEY_RAW,
      LEGACY_APP_VERSION_STORAGE_KEY,
    ]
    const foundKey = candidates.find(k => localStorage.getItem(k))
    if (!foundKey) return
    const legacy = localStorage.getItem(foundKey)
    if (legacy) localStorage.setItem(APP_VERSION_STORAGE_KEY, legacy)
  } catch (e) {
    // localStorage erişimi engellenmiş olabilir (privacy mode vb.)
  }
}
